import React from "react";
import Sidebar from "../../../components/Sidebar";
import RecommendCareers from "../../../components/recommendCareers/RecommendCareers";
import { Outlet, useLocation } from "react-router-dom";
const RecommedCareersHome = () => {
  const location = useLocation();
  return (
    <Sidebar>
      {location.pathname === "/dashboard/recommended-careers" && (
        <RecommendCareers />
      )}
      <Outlet />
    </Sidebar>
  );
};
export default RecommedCareersHome;
